module.exports = __webpack_public_path__ + "img/DISPTCHD.4b40af3a.svg";